import { defineComponent as _defineComponent } from 'vue'
import MembershipTermsModal from '@/modules/authentication/components/MembershipTermsModal/MembershipTermsModal.vue';
import { goToNextRoute } from '@/modules/common/store/RegulatoryUpdateRoutesOrchestrator';
import { acceptTerms } from '@/modules/account/views/RegulatoryUpdate/services';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegulatoryUpdateAcceptTerms',
  setup(__props) {

async function fetchAcceptTerms() {
  try {
    await acceptTerms();

    goToNextRoute();
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao aceitar os termos. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  }
}

return { __sfc: true,fetchAcceptTerms, MembershipTermsModal }
}

})